<div *ngIf="viewInitialized && pageDetails?.title" class="panel-header">
    <h1 class="panel-title">
        <a class="hover-link"
           *ngIf="link; else action"
           [routerLink]="[link]"
           [fragment]="fragment"
           [queryParams]="queryParams"
           [state]="state">
            {{ pageDetails.title }}
        </a>
        <ng-template #action><a class="hover-link" *ngIf="onOpen; else plain" (click)="open()">{{pageDetails.title}}</a></ng-template>
        <ng-template #plain>{{pageDetails.title}}</ng-template>
        <span class="panel-title-info" *ngIf="pageDetails.info">{{pageDetails.info}}</span>
        <ng-container *ngIf="pageDetails?.copyValue">
            <app-action-icon style="vertical-align: middle"
                             icon="clipboard"
                             size="xs"
                             colorClass="primary"
                             [tooltip]="pageDetails.copyTooltip || 'Copy'"
                             (click)="copyPageValue($event)">
            </app-action-icon>
        </ng-container>
    </h1>
    <div class="add-on">
        <ng-container *ngTemplateOutlet="componentIcons"></ng-container>
        <ng-container *ngFor="let i of actions">
            <ng-container *ngxPermissionsOnly="i.permissions">
                <ng-container [ngTemplateOutlet]="i.callback ? addOnActionIcon : addOnLink"></ng-container>
                <ng-template #addOnActionIcon>
                    <app-action-icon *ngIf="!i.shouldShowAction || (i.shouldShowAction(data) | async)"
                                     [icon]="i.icon"
                                     size="lg"
                                     [active]="i.active && (i.active(data) | async)"
                                     (click)="i.callback ? i.callback(data) : $event.preventDefault()"
                                     [tooltip]="i.caption">
                    </app-action-icon>
                </ng-template>
                <ng-template #addOnLink>
                    <a class="hover-link" [routerLink]="[link]" [fragment]="fragment" [state]="state">
                        <ng-container *ngTemplateOutlet="addOnActionIcon"></ng-container>
                    </a>
                </ng-template>
            </ng-container>
        </ng-container>
    </div>
</div>
<div class="panel-body">
    <ng-container #vc></ng-container>
</div>
<div *ngIf="onOpen || link" class="text-primary hover-link panel-link">
    <a *ngIf="link; else action"
       class="text-primary hover-link panel-link"
       [routerLink]="link"
       [fragment]="fragment"
       [queryParams]="queryParams"
       [state]="state">
        {{openDetailsText}}
    </a>
    <ng-template #action>
        <div *ngIf="onOpen" class="text-primary hover-link panel-link" (click)="open()">
            {{openDetailsText}}
        </div>
    </ng-template>
    <fal i="arrow-right" class="ml-1"></fal>
</div>
